import {
  DataGridLayout,
  DateRangeFilter,
  DESC,
  Filters,
  FiltersLayout,
  List,
  ListHeader,
  ListPageLayout,
} from 'framework/list';
import useContractsService from 'domain/people/contracts/shared/contractsService';
import { BadgeField, DateField, TextField } from 'framework/ui/field';
import EmployeeContractWillExpireSoonBadge from 'domain/people/contracts/shared/RelatedContractsList/badge/EmployeeContractWillExpireSoonBadge';
import { ActiveBadge, ExpiredBadge } from 'framework/ui/ui-builder';
import ViewContractButton from 'domain/people/contracts/List/button/ViewContractButton';
import {
  EmployeeOfficeField,
  OfficeFilterById,
  EmployeeLinkField,
  EmployeeFilter,
  ContractTypeFilter,
} from 'domain/shared/employee';
import ContractCategoryField from 'domain/people/contracts/shared/field/ContractCategoryField';
import ContractDurationField from 'domain/people/contracts/shared/field/ContractDurationField';
import ContractEndDateBadgeField from 'domain/people/contracts/shared/field/ContractEndDateBadgeField';

const ContractsList = () => {
  const { search, isContractActive, isContractExpired, isContractWillExpireSoon, getFiltersValidationSchema } =
    useContractsService();

  const filters = (
    <Filters getValidationSchema={getFiltersValidationSchema}>
      <FiltersLayout>
        <EmployeeFilter source="employee.alias" label="Worker" />
        <DateRangeFilter canBeInFuture source="dateOfSignature" label="Date of signature" />
        <DateRangeFilter canBeInFuture source="startDate" label="Contract start date" />
        <DateRangeFilter canBeInFuture source="endDate" label="Contract end date" />
        <OfficeFilterById source="officeId" label="Office" />
        <ContractTypeFilter source="contractType" label="Contract type" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List getDataMethod={search} defaultSortOrder={DESC} defaultSortField="dateOfSignature">
      <ListPageLayout filter={filters} header={<ListHeader label="Contracts" icon="icon-docs" />}>
        <DataGridLayout buttons={[<ViewContractButton source="id" variant="outlined" />]}>
          <EmployeeLinkField
            source="employeeAlias"
            nameSource="employeeAlias"
            label="Worker ID"
            isSortable
            width={105}
          />
          <TextField
            source="employeeName"
            label="Worker name"
            isSortable
            sortSource="employee.nameEn.lastName"
            width={130}
          />
          <TextField source="employeePositionName" label="Worker position" isSortable width={140} />
          <TextField source="number" label="Contract number" isSortable width={135} />
          <DateField source="dateOfSignature" label="Date of signature" isSortable width={135} />
          <DateField source="startDate" label="Contract start date" isSortable width={145} />
          <ContractDurationField dateFromSource="startDate" dateToSource="endDate" label="Duration" width={135} />
          <BadgeField
            badges={[
              <EmployeeContractWillExpireSoonBadge
                id="expireSoon"
                isVisible={({ endDate }) => isContractWillExpireSoon(endDate)}
              />,

              <ActiveBadge
                id="activeContract"
                isVisible={({ startDate, endDate }) => isContractActive(startDate, endDate)}
              />,
              <ExpiredBadge id="expiredContract" isVisible={({ endDate }) => isContractExpired(endDate)} />,
            ]}
            isSortable
            source="endDate"
            label="Contract end date"
            width={175}
          >
            <ContractEndDateBadgeField />
          </BadgeField>
          <EmployeeOfficeField source="officeId" label="Office" width={90} />
          <ContractCategoryField source="secondary" label="Category" width={105} />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default ContractsList;
